<template>
<div class="box con-tracks">
  <com-h1 title="演讲专题"></com-h1>
  <com-search></com-search>
  <div class="container">
    <section class="tracks" v-for="(topic, idx) in topicsArr" :key="idx">
      <router-link :to="'/track/' + topic.id" :class="['track','is-transition',topic.isHotTopic?'active':'']">
      <h1 class="title">{{topic.topic}}</h1>
        <div class="introduce" v-html="topic.introduce">
        </div>
      </router-link>
      <ul class="columns is-multiline">
        <li class="column is-one-third" v-for="(lectureId, idx) in topic.lectureIds" :key="idx">
          <div class="lecture is-transition">
            <!-- 一个议题一个讲师 -->
            <template v-if="lectures[lectureId].speakerIds.length === 1">
              <div class="up">
                <div class="left">
                  <router-link :to="'/presentation/' + lectureId">
                    <img class="avatar" :src="lectures[lectureId].speaker.avatar+'?imageView2/0/w/800'">
                  </router-link>
                </div>
                <div class="right">
                  <div class="title">
                    <router-link :to="'/presentation/' + lectureId">
                      {{lectures[lectureId].title}}
                    </router-link>
                  </div>
                  <div class="speaker">
                    <span class="name">{{lectures[lectureId].speaker.name}} / </span>
                    <span class="position">
                      {{lectures[lectureId].speaker.company}} {{lectures[lectureId].speaker.position}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="down-tag">
                <router-link :to="{path: '/search', query: {id: tags[tid].tag_id}}" v-for="(tid, idx) in lectures[lectureId].tag_ids" class="l-tag" :key="idx" v-html="tags[tid].name"></router-link>
              </div>
            </template>
            <!-- 一个议题多个讲师 -->
            <template v-else>
              <div class="one-vs-many">
                <router-link :to="'/presentation/' + lectureId">
                  <div class="title is-small">
                    {{lectures[lectureId].title}}
                  </div>
                </router-link>
                <div
                  v-for="(sid, index) in lectures[lectureId].speakerIds" v-if="speakers[sid]" :key="index" class="down">
                  <div class="left">
                    <router-link :to="'/presentation/' + lectureId">
                      <img class="avatar is-small" :src="speakers[sid].avatar+'?imageView2/0/w/800'">
                    </router-link>
                  </div>
                  <div class="right">
                    <div class="speaker">
                      <span class="name">{{speakers[sid].name}} / </span>
                      <span class="position">
                        {{speakers[sid].company}} {{speakers[sid].position}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="down-tag">
                  <router-link :to="{path: '/search', query: {id: tags[tid].tag_id}}" v-for="(tid, idx) in lectures[lectureId].tag_ids" class="l-tag" :key="idx" v-html="tags[tid].name"></router-link>
                </div>
              </div>
            </template>
          </div>
        </li>
      </ul>
    </section>
  </div>
</div>
</template>

<script>
// import Topics from '../com-topics'
import ComH1 from '../com-h1'
import ComSearch from '../com-search'

export default {
  data () {
    return {
    }
  },
  components: {
    // Topics,
    ComH1,
    ComSearch
  },
  computed: {
    lectures () {
      return this.$store.state.lectures
    },
    speakers () {
      return this.$store.state.speakers
    },
    tags () {
      return this.$store.state.tags
    },
    topicsArr () {
      return this.$store.state.topicsArr.filter(item => item.is_previous !== true)
    }
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.con-tracks
  background-color: #f7f8f8
  .tracks
    position: relative
    margin-bottom: 30px
    .track
      display: block
      width: 100%
      background-color: white
      box-shadow: 0px 1px 2px #ccc
      margin-bottom: 20px
      padding: 15px 20px
      .title
        display: block
        font-size: 20px
        color: var(--primary-color)
        +mobile
          font-size: 16px
      .introduce
        display: block
        font-size: 14px
        color: #888
        margin-top: 10px
        +mobile
          font-size: 12px
    .active
      &:after
        content: ''
        width: 36px
        height: 36px
        background-image: url(../../assets/img/hot-tag.png)
        background-size: 36px
        background-repeat: no-repeat
        background-position: center
        display: block
        position: absolute
        right: 0
        top: 0

.lecture
  background-color: #fff
  border: 1px solid #e5e9f2
  padding: 8px
  &:hover
    box-shadow: 0px 1px 20px #ccc
  .down-tag
    margin: 10px 0 8px
    padding: 0 8px
    .l-tag
      font-size: 12px
      color: #888
      padding: 2px 15px
      border: 1px solid #888
      border-radius: 15px
      margin-right: 10px
      transition: all 0.3s linear
      &:hover
        border-color: var(--primary-color)
        color: var(--primary-color)
  .up, .one-vs-many
    display: flex
    align-items: center
    // height: 147px
    transition: all 0.3s linear
    +mobile
      height: auto
    .left
      flex-shrink: 0
    .avatar
      display: block
      width: 83px
      height: 83px
      border-radius: 83px
      margin-right: 10px
      &.is-small
        width: 40px
        height: 40px
      +mobile
        width: 60px
        height: 60px
        border-radius: 50%
        margin-right: 20px
    .title
      font-size: 15px
      color: var(--primary-color)
      a
      &.is-small
        font-size: 14px
      +mobile
        font-size: 14px
      a:hover
        color: var(--primary-color)
    .speaker
      margin-top: 8px
      font-size: 12px
      color: #888
      +mobile
        margin-top: 2px

  .one-vs-many
    display: block
    .down
      display: flex
      align-items: center
      margin-top: 10px
</style>
